module.exports = __webpack_public_path__ + "f11401e10c75ce3e9993ddfe159b6e23.jpg";